export const ThresholdLegend = () => null;

ThresholdLegend['displayName'] = 'MeterBarChart.ThresholdLegend';
